import React from 'react'
import BbpsCommSche from '../../../components/bbps/dmtCommSche/DmtCommSche'
function BbpsCommiosionSche() {
  return (
    <div><BbpsCommSche/></div>
  )
}

export default BbpsCommiosionSche